import moment from 'moment';
import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { acInquiryActionTypes } from '../actions/actionTypes';
import { updateFilterReducer, updateTableConfig } from '../../../report/redux/reducers/utilities/utility';
import { commonTypes } from '../../../../common/redux/actions/commonActions';

export const REDUCER_NAME = 'AccountingInquiryFilterList';

const logErrListReq = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: moment().format(),
  loading: true,
  serverRequestError: null,
});

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});
function AccountingInqFilterListConfig(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // config list column configuration
    case acInquiryActionTypes.UPDATE_ACINQ_FILTER_CONFIG:
      return {
        ...state,
        ...updateFilterReducer(action),
      };
    case acInquiryActionTypes.REMOVE_ACINQ_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    case acInquiryActionTypes.UPDATE_ACINQ_COLUMN_CONFIG:
      return {
        ...state,
        listSortOptions: action.data.sortOptions,
        listColumnOrder: action.data.columnOrder,
      };
    default:
      return null;
  }
}

function AccountingInqFilterListREQRES(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // log request
    case acInquiryActionTypes.LOG_ACINQ_LIST_REQUEST:
      return logErrListReq(state, action);
    // log error
    case acInquiryActionTypes.GET_ACINQ_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: moment().format(),
        loading: false,
      };
    // store response
    case acInquiryActionTypes.GET_ACINQ_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: moment().format(),
        loading: false,
      };
    case acInquiryActionTypes.RESET_ACINQ_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case acInquiryActionTypes.UPDATE_ACINQ_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    case acInquiryActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
}

const AccountingInquiryFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = AccountingInqFilterListConfig(state, action);
  const stateReqRes = AccountingInqFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default AccountingInquiryFilterList;
